<template>
    <div class="menu-list">
        <div class="menu-item" v-for="(menuItem, menuKey) in menuList" :key="menuKey" @click="handleMenuItem(menuItem, menuKey)">
            <div class="menu-item-img">
                <img v-show="menuItem.activeIcon && menuKey === value" :src="menuItem.activeIcon" alt="">
                <img v-show="menuItem.icon && menuKey !== value" :src="menuItem.icon" alt="">
            </div>
            <div class="menu-item-name">{{menuItem.name}}</div>
            <div class="menu-item-icon">
                <img v-show="menuKey === value" src="@/assets/home/triangle_select.png" alt="">
                <img v-show="menuKey !== value" src="@/assets/home/triangle_unselect.png" alt="">
            </div>
        </div>
        <div class="menu-slide" :style="`transform: translateY(${48 * value}px)`"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    props: {
        value: {
            type: String | Number,
            default: 0
        },
        menuList: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    model: {
        "prop": "value",
        "event": 'change'
	},
	methods: {
		// 点击菜单项时触发
		handleMenuItem(menuItem, menuKey) {
			this.$emit('change', menuKey)
            this.$emit('select', {
                menuItem: menuItem,
                menuKey: menuKey
            })
		}
	}
}
</script>

<style lang="scss" scoped>
.menu-list {
    position: relative;
    .menu-item {
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 48px;
        cursor: pointer;
        user-select: none;
        .menu-item-img {
            margin-left: 25px;
            width: 14px;
            height: 16px;
            > img {
                width: 100%;
                height: 100%;
            }
        }
        .menu-item-name {
            margin-left: 14px;
            font-size: 14px;
            line-height: 48px;
            color: #333;
        }
        .menu-item-icon {
            position: absolute;
            right: 20px;
            top: 0;
            bottom: 0;
            margin: auto 0;
            width: 5px;
            height: 9px;
            > img {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }
        }
    }
	.menu-slide {
		position: absolute;
		width: 4px;
		height: 48px;
		left: 0;
		top: 0;
		background: #0061E4;
		transition: all .15s;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/menu/menu.vue